<ion-item lines="none" *ngIf="timerIsActive">
  <ion-icon color="light" slot="start" name="time"></ion-icon>
  <ion-label color="light" class="ion-text-wrap">
    After <app-countdown-timer *ngIf="timerIsActive" [timerSec]="interval" [start]="timerIsActive" [reset]="!timerIsActive"
      (finished)="onTimerFinished()"></app-countdown-timer>
    minutes you will be automatically logged out!
  </ion-label>
</ion-item>